class PromoPopup {
  constructor(container) {
    this.container = container;
    this.popupModal = container.querySelector(".sign-up-popup-modal");
    this.overlay = container.querySelector(".sign-up-popup-overlay");
    this.closeButton = this.popupModal.querySelector(".popup-modal__close");
    this.dismissButton = this.popupModal.querySelector(
      ".popup-modal__dismiss-btn"
    );

    this.form = this.popupModal.querySelector(".newsletter-form");
    this.emailInput = this.form?.querySelector('input[type="email"]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.formError = this.form?.querySelector(".newsletter-form__message");

    this.successModal = container.querySelector(".success-popup-modal");
    this.successOverlay = container.querySelector(".success-popup-overlay");
    this.copyButton = this.successModal?.querySelector(
      ".popup-modal__copy-btn"
    );
    this.copySuccessMsg = this.successModal?.querySelector(
      ".popup-modal__success-msg"
    );
    this.successCloseButton = this.successModal?.querySelector(
      ".popup-modal__close"
    );
    this.successDismissButton = this.successModal?.querySelector(
      ".popup-modal__dismiss-btn"
    );

    this.sectionId = this.popupModal.dataset.sectionId;
    this.testMode = this.popupModal.dataset.testMode === "true";
    this.delaySeconds = parseInt(this.popupModal.dataset.delaySeconds);
    this.delayDays = parseInt(this.popupModal.dataset.delayDays);
    this.displayTimer = this.popupModal.dataset.displayTimer === "true";
    this.timerDuration = parseFloat(this.popupModal.dataset.timerDuration) * 60;

    this.minutesElement = this.popupModal.querySelector(
      ".popup-modal__timer__minutes"
    );
    this.secondsElement = this.popupModal.querySelector(
      ".popup-modal__timer__seconds"
    );

    this.storageKey = `promo-popup-${window.location.host}-${this.sectionId}`;

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.checkAndShowPopup();
    if (this.form) {
      this.setupFormSubmission();
    }

    if (this.testMode) {
      if (this.displayTimer) this.startTimer();
      return;
    }
  }

  setupEventListeners() {
    this.closeButton.addEventListener("click", () => this.closePopup());
    if (this.dismissButton) {
      this.dismissButton.addEventListener("click", () => this.closePopup());
    }
    this.overlay.addEventListener("click", () => this.closePopup());

    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(
        'a[href="#promo-popup"], [data-promo-popup-trigger]'
      );
      if (trigger) {
        e.preventDefault();
        this.showPopup();
      }
    });

    if (this.successModal) {
      if (this.copyButton) {
        this.copyButton.addEventListener("click", () => this.handleCopyCode());
      }

      if (this.successCloseButton) {
        this.successCloseButton.addEventListener("click", () =>
          this.closeSuccessPopup()
        );
      }
      if (this.successDismissButton) {
        this.successDismissButton.addEventListener("click", () =>
          this.closeSuccessPopup()
        );
      }
      if (this.successOverlay) {
        this.successOverlay.addEventListener("click", () =>
          this.closeSuccessPopup()
        );
      }
    }
  }

  setupFormSubmission() {
    this.form.addEventListener("submit", async (e) => {
      e.preventDefault();

      if (!this.emailInput.value) return;

      try {
        this.submitButton.disabled = true;

        const formData = new FormData(this.form);
        const response = await fetch(this.form.action, {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });

        if (response.ok) {
          localStorage.setItem(
            "promo-bar-subscribed-" + window.location.host,
            JSON.stringify({ subscribed: true })
          );
          this.showSuccessPopup();
        } else {
          const data = await response.json().catch(() => null);
          const message =
            data?.errors?.email?.[0] || "Something went wrong. Please try again.";
          this.showFormError(message);
        }
      } catch (error) {
        console.error("Error:", error);
        this.showFormError("An error occurred. Please try again.");
      } finally {
        this.submitButton.disabled = false;
      }
    });
  }

  calculateNextDisplayDate() {
    const now = new Date();
    return new Date(
      now.getTime() + this.delayDays * 24 * 60 * 60 * 1000
    ).toISOString();
  }

  checkAndShowPopup() {
    const stored = localStorage.getItem(this.storageKey);

    if (stored) {
      const { next_display_date, dismissed } = JSON.parse(stored);
      const nextDate = new Date(next_display_date);

      if (nextDate > new Date()) {
        return;
      }
    }

    setTimeout(() => {
      this.showPopup();
    }, this.delaySeconds * 1000);
  }

  showPopup() {
    this.popupModal.classList.add("popup-modal--active");
    this.overlay.classList.add("popup-overlay--active");

    if (this.displayTimer) {
      this.startTimer();
    }
  }

  closePopup() {
    this.popupModal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");

    if (!this.testMode) {
      localStorage.setItem(
        this.storageKey,
        JSON.stringify({
          next_display_date: this.calculateNextDisplayDate(),
          dismissed: false,
        })
      );
    }
  }

  showSuccessPopup() {
    if (this.successModal) {
      this.closePopup();
      this.successModal.classList.add("popup-modal--active");
      this.successOverlay.classList.add("popup-overlay--active");
    }
  }

  closeSuccessPopup() {
    if (this.successModal) {
      this.successModal.classList.remove("popup-modal--active");
      this.successOverlay.classList.remove("popup-overlay--active");
    }
  }

  async handleCopyCode() {
    if (this.copyButton) {
      const discountCode = this.successModal.querySelector(
        "#DiscountCode--" + this.sectionId
      );

      if (discountCode) {
        console.log("Attempting to copy discount code:", discountCode.value);

        document.body.focus();
        this.copyButton.focus();

        await this.copyToClipboardFallback(discountCode.value);

        if (this.copySuccessMsg) {
          this.copySuccessMsg.style.display = "block";
          setTimeout(() => {
            this.copySuccessMsg.style.display = "none";
          }, 3000);
        }
      } else {
        console.error("Discount code element not found.");
      }
    }
  }

  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Text copied successfully!");
    } catch (err) {
      console.error("Failed to copy text using navigator.clipboard:", err);
    }
  }

  copyToClipboardFallback(text) {
    const tempNode = document.createElement("div");
    tempNode.innerHTML = text;

    function listener(e) {
      e.clipboardData.setData("text/html", text);
      e.clipboardData.setData("text/plain", text);
      e.preventDefault();
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
  }
  showFormError(message) {
    if (this.formError) {
      this.formError.textContent = message;
      this.formError.style.display = "block";

      setTimeout(() => {
        this.formError.style.display = "none";
      }, 5000);
    }
  }

  startTimer() {
    let timeLeft = this.timerDuration;

    const updateTimer = () => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      this.minutesElement.textContent = minutes.toString().padStart(2, "0");
      this.secondsElement.textContent = seconds.toString().padStart(2, "0");

      if (timeLeft > 0) {
        timeLeft--;
        setTimeout(updateTimer, 1000);
      } else {
        this.closePopup();
      }
    };

    updateTimer();
  }
}

// Pick-to-reveal tag sheet. Kept apart from PromoPopup because it is one
// sheet moving through steps (pick, reward, done) rather than two modals, and
// because it remembers more between page loads: which tag was picked, and
// whether to show the corner tag instead of opening on its own again.
class DsTagPopup {
  constructor(root) {
    this.root = root;
    this.sheet = root.querySelector(".ds-sheet");
    this.tags = Array.from(root.querySelectorAll("[data-ds-pick-card]"));
    this.teaser = root.querySelector("[data-ds-teaser]");
    this.form = root.querySelector(".ds-signup");
    this.emailInput = this.form?.querySelector('input[type="email"]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.error = root.querySelector("[data-ds-error]");

    this.sectionId = root.dataset.sectionId;
    this.testMode = root.dataset.testMode === "true";
    this.delaySeconds = parseInt(root.dataset.delaySeconds);
    this.delayDays = parseInt(root.dataset.delayDays);
    this.storageKey = `promo-popup-${window.location.host}-${this.sectionId}`;
    this.subscribedKey = "promo-bar-subscribed-" + window.location.host;
    this.reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    this.bindEvents();
    this.start();
  }

  bindEvents() {
    // Only the X and the button after signing up carry data-ds-close. The
    // backdrop deliberately does nothing, so a stray tap cannot close it.
    this.root.querySelectorAll("[data-ds-close]").forEach((button) => {
      button.addEventListener("click", () => this.close());
    });
    this.teaser?.addEventListener("click", () => this.open());
    this.tags.forEach((tag, index) => {
      tag.addEventListener("click", () => this.pick(index));
    });
    this.form?.addEventListener("submit", (e) => this.submit(e));
    this.emailInput?.addEventListener("input", () => this.showError(null));

    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(
        'a[href="#promo-popup"], [data-promo-popup-trigger]'
      );
      if (trigger) {
        e.preventDefault();
        this.open();
      }
    });
  }

  start() {
    if (this.testMode) return;

    let subscribed = false;
    try {
      subscribed = !!localStorage.getItem(this.subscribedKey);
    } catch (e) {}
    if (subscribed) return;

    const state = this.readState();
    if (Number.isInteger(state.picked) && this.tags[state.picked]) {
      this.markPicked(state.picked);
      this.root.dataset.step = "reward";
    }

    // Closed recently: it does not open on its own, but the corner tag stays
    // so the visitor can get back to it.
    if (
      state.next_display_date &&
      new Date(state.next_display_date) > new Date()
    ) {
      this.root.dataset.dismissed = "true";
      return;
    }

    setTimeout(() => {
      this.afterConsentBanner(() => this.open());
    }, this.delaySeconds * 1000);
  }

  // Shopify's cookie banner sits above everything (z-index 2000000), so a
  // sheet opened while it is up is hidden behind it. Wait until it is gone.
  // This checks the banner element itself: customerPrivacy.shouldShowBanner()
  // was seen returning false while the banner was on screen.
  afterConsentBanner(callback) {
    const bannerVisible = () => {
      const banner = document.getElementById("shopify-pc__banner");
      if (!banner || !banner.isConnected) return false;
      const style = window.getComputedStyle(banner);
      return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        parseFloat(style.opacity) > 0 &&
        banner.getBoundingClientRect().height > 0
      );
    };

    if (!bannerVisible()) {
      callback();
      return;
    }

    const poll = setInterval(() => {
      if (bannerVisible()) return;
      clearInterval(poll);
      setTimeout(callback, 1000);
    }, 500);
  }

  open() {
    this.root.dataset.open = "true";
    try {
      this.sheet.focus({ preventScroll: true });
    } catch (e) {
      this.sheet.focus();
    }
  }

  close() {
    const hadFocus = this.sheet.contains(document.activeElement);
    this.root.dataset.open = "false";
    if (this.root.dataset.step === "done") return;

    this.root.dataset.dismissed = "true";
    this.writeState({ next_display_date: this.nextDisplayDate() });
    if (hadFocus && this.teaser) this.teaser.focus({ preventScroll: true });
  }

  pick(index) {
    if (this.root.dataset.step !== "pick" || this.tags[index].disabled) return;

    this.markPicked(index);
    this.writeState({ picked: index });
    try {
      if (navigator.vibrate) navigator.vibrate(15);
    } catch (e) {}

    // Let the tag finish turning before the sheet changes, otherwise the
    // reveal is over before the eye gets there.
    setTimeout(
      () => {
        this.root.dataset.step = "reward";
      },
      this.reduceMotion ? 0 : 850
    );
  }

  markPicked(index) {
    this.tags.forEach((tag, i) => {
      tag.classList.toggle("is-picked", i === index);
      tag.classList.toggle("is-out", i !== index);
      tag.disabled = true;
    });
  }

  async submit(e) {
    e.preventDefault();

    const email = this.emailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      this.showError(this.error?.dataset.invalidMessage);
      this.emailInput.focus();
      return;
    }

    try {
      this.submitButton.disabled = true;

      const response = await fetch(this.form.action, {
        method: "POST",
        body: new FormData(this.form),
        headers: { Accept: "application/json" },
      });

      if (response.ok) {
        try {
          localStorage.setItem(
            this.subscribedKey,
            JSON.stringify({ subscribed: true })
          );
        } catch (err) {}
        this.showError(null);
        this.root.dataset.step = "done";
      } else {
        // Shopify's own error text follows the store language, which is
        // English here, so the Romanian message from the settings is used.
        this.showError(this.error?.dataset.failedMessage);
      }
    } catch (error) {
      console.error("Error:", error);
      this.showError(this.error?.dataset.failedMessage);
    } finally {
      this.submitButton.disabled = false;
    }
  }

  showError(message) {
    if (!this.error) return;
    this.error.hidden = !message;
    if (message) this.error.textContent = message;
    this.emailInput?.setAttribute("aria-invalid", message ? "true" : "false");
  }

  nextDisplayDate() {
    return new Date(
      Date.now() + this.delayDays * 24 * 60 * 60 * 1000
    ).toISOString();
  }

  readState() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || {};
    } catch (e) {
      return {};
    }
  }

  writeState(patch) {
    if (this.testMode) return;
    try {
      localStorage.setItem(
        this.storageKey,
        JSON.stringify({ ...this.readState(), ...patch })
      );
    } catch (e) {}
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(
    '[data-section-type="newsletter-popup"]'
  );
  sections.forEach((section) => {
    if (section.hasAttribute("data-ds-tag-popup")) {
      new DsTagPopup(section);
      return;
    }
    new PromoPopup(section.closest("section, .shopify-section"));
  });
});
